import React from 'react';
import classNames from 'classnames';
import styles from './TextBadge.module.scss';

interface TextBadgeProps {
	text: string;
	className?: string;
}

/**
 * Text label badge component for displaying short labels like "Primary", "Secondary 1".
 */
export const TextBadge: React.FunctionComponent<TextBadgeProps> = ({ text, className }) => {
	return <span className={classNames(styles.textBadge, className)}>{text}</span>;
};
